
import {
    GovBanner
  } from '@trussworks/react-uswds';
  const Usabanner = () => {
      return (
        <>
          <GovBanner />
        </>
          )
      }
  export default Usabanner;